import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

type Props = {
  description: string
}

const CenterEventDescriptionSection = ({ description }: Props) => {
  return (
    <InnerBox>
      <div className="flex flex-col gap-2">
        <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
          Description :
        </Typography>
        <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
          {description}
        </Typography>
      </div>
    </InnerBox>
  )
}

export default CenterEventDescriptionSection
